import { render, staticRenderFns } from "./ExamineList.vue?vue&type=template&id=21694b24&scoped=true&"
import script from "./ExamineList.vue?vue&type=script&lang=js&"
export * from "./ExamineList.vue?vue&type=script&lang=js&"
import style0 from "./ExamineList.vue?vue&type=style&index=0&id=21694b24&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21694b24",
  null
  
)

export default component.exports